import { is, propOr } from 'ramda'

export const isValidSearch = search => !!search && is(String, search)

export const matchTextSearch = (value, search) => {
  if (!isValidSearch(search)) return true
  return propOr(value, 'name', value) //
    ?.toLowerCase()
    ?.includes((search || '').toLowerCase())
}

export const filterByTextSearch = (list, search) => {
  if (!isValidSearch(search)) return list
  if (!is(Array, list)) return list
  return list?.filter(value => matchTextSearch(value, search))
}
